/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {Model, ModelMixin} from '../../../common/model.class';
import * as moment from 'moment';
import Moment = moment.Moment;
import keys = require('core-js/fn/object/keys');

export class BoardAffiliationInformation extends ModelMixin() implements Model<BoardAffiliationInformation> {

    TYPE = BoardAffiliationInformation;

    public hasAbms: boolean;
    public hasAbps: boolean;
    public hasAoa: boolean;
    public specialtyExaminationDate: Moment;

    constructor(jsonData: any = {}) {
        super();
        if (jsonData.specialtyExaminationDate) jsonData.specialtyExaminationDate = moment(jsonData.specialtyExaminationDate);
        Object.assign(this, jsonData);
    }

    isEmpty(): boolean {
        return keys(this)
            .filter(it => it !== 'TYPE')
            .every(it => this[it] === undefined);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/board/information/board-affiliation-information.model.ts